import { QueryParamsForGetRequest } from "./types";

const appendSearchParamsByQueryParams = (
  queryParams: QueryParamsForGetRequest,
  searchParams: URLSearchParams,
): void =>
  Object.entries(queryParams).forEach(([key, value]) => {
    if (!value) {
      return;
    }

    if (Array.isArray(value)) {
      searchParams.append(key, `[${[value.join(",")]}]`);
      /*  value.forEach(arrayItemValue => {
        if (arrayItemValue) {
          searchParams.append(key, String(arrayItemValue));
        }
      }); */
    } else {
      searchParams.append(key, String(value));
    }
  });

const getStringUrlBySearchParams = (
  url: string | URL,
  searchParams: URLSearchParams,
) =>
  url instanceof URL ? url.toString() : `${url}?${searchParams.toString()}`;

export const appendQueryToUrl = (
  baseUrl: string,
  queryParams: QueryParamsForGetRequest,
) => {
  let url;

  try {
    url = new URL(baseUrl);
  } catch {
    url = baseUrl;
  }

  const searchParams =
    url instanceof URL ? url.searchParams : new URLSearchParams();

  appendSearchParamsByQueryParams(queryParams, searchParams);

  return getStringUrlBySearchParams(url, searchParams);
};
